import { useToast } from "@/hooks/useToast";
import { Toast, ToastDescription } from "./toast";

export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 w-full max-w-sm">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          variant={toast.variant}
          onClose={() => dismiss(toast.id)}
        >
          <ToastDescription>{toast.description}</ToastDescription>
        </Toast>
      ))}
    </div>
  );
}
